import { SimpleGrid, Stack, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../../shared/components/PageHeader";
import { DocumentTypeActionCard } from "./DocumentTypeActionCard";
import { OrderTrackingActionCard } from "./OrderTrackingActionCard";
import { WelcomeRequestFeed } from "./WelcomeRequestFeed";
import type { WelcomeDashboardProps } from "./WelcomeDashboard";

export function WelcomeManagerView({
  userName,
  primaryLocation,
  recentRequests,
  documentTypes,
  requestsBasePath,
  isLoadingRequests,
  orderTrackingHref,
}: WelcomeDashboardProps) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 48em)");

  const subtitle = primaryLocation
    ? `${t("welcome.subtitle")} · ${primaryLocation}`
    : t("welcome.subtitle");

  return (
    <Stack
      gap={isMobile ? "md" : "xl"}
      py={{ base: "md", sm: "xl" }}
      data-tour-id="welcome-dashboard"
    >
      <PageHeader
        title={t("welcome.title", { name: userName })}
        subtitle={subtitle}
      />

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing={{ base: "md", sm: "xl" }}>
        {(documentTypes.length > 0 || orderTrackingHref) && (
          <Stack gap="sm">
            <Title
              order={2}
              size="h5"
              fw={600}
              tt="uppercase"
              c="dimmed"
              lts="0.08em"
            >
              {t("welcome.quickActions")}
            </Title>
            {documentTypes.map((dt) => (
              <DocumentTypeActionCard key={dt.id} docType={dt} />
            ))}
            {orderTrackingHref ? (
              <OrderTrackingActionCard href={orderTrackingHref} />
            ) : null}
          </Stack>
        )}

        <Stack gap="sm" data-tour-id="welcome-recent-activity">
          <Title
            order={2}
            size="h5"
            fw={600}
            tt="uppercase"
            c="dimmed"
            lts="0.08em"
          >
            {t("welcome.recentActivity")}
          </Title>
          <WelcomeRequestFeed
            requests={recentRequests}
            requestsBasePath={requestsBasePath}
            isLoading={isLoadingRequests}
          />
        </Stack>
      </SimpleGrid>
    </Stack>
  );
}
